import { defineComponent as w, ref as C, computed as A, useTemplateRef as M, createElementBlock as v, openBlock as a, createElementVNode as c, createVNode as n, createStaticVNode as N, Fragment as D, renderList as I, createBlock as m, createCommentVNode as $, unref as t, toDisplayString as j, withCtx as f } from "vue";
import { useModal as z, ScalarMarkdown as B, ScalarButton as p, ScalarIcon as E, ScalarModal as U } from "@scalar/components";
import { ScalarIconTrash as V } from "@scalar/icons";
import { emitCustomEvent as T } from "@scalar/workspace-store/events";
import L from "../../components/Sidebar/Actions/DeleteSidebarListElement.vue.js";
import { useActiveEntities as P } from "../../store/active-entities.js";
import R from "./CollectionServerForm.vue.js";
import { useWorkspace as F } from "../../store/store.js";
const O = {
  ref: "wrapper-ref",
  class: "flex h-full w-full flex-col gap-12 px-1.5 pt-8"
}, W = { class: "flex flex-col gap-4" }, Y = { class: "rounded-lg border" }, q = { class: "bg-b-2 flex items-start justify-between rounded-t-lg py-1 pr-1 pl-3 text-sm" }, G = {
  key: 1,
  class: "self-center"
}, H = { class: "text-c-3 flex h-full items-center justify-center rounded-lg border p-4" }, oe = /* @__PURE__ */ w({
  __name: "CollectionServers",
  setup(J) {
    const { activeCollection: s } = P(), { servers: d, events: x, serverMutators: h } = F(), u = z(), l = C(null), _ = A(() => {
      var r;
      return !d || !((r = s.value) != null && r.servers) ? [] : Object.values(d).filter(
        (e) => {
          var i;
          return (i = s.value) == null ? void 0 : i.servers.includes(e.uid);
        }
      );
    }), S = () => x.commandPalette.emit({
      commandName: "Add Server"
    }), g = () => {
      var r, e;
      !((r = s.value) != null && r.uid) || !l.value || (h.delete(l.value, s.value.uid), T(k.value, "scalar-delete-server", {
        url: ((e = d[l.value]) == null ? void 0 : e.url) ?? ""
      }), u.hide());
    }, b = (r) => {
      l.value = r, u.show();
    }, k = M("wrapper-ref");
    return (r, e) => {
      var i;
      return a(), v("div", O, [
        c("div", W, [
          e[2] || (e[2] = N('<div class="flex items-start justify-between gap-2"><div class="flex flex-col gap-2"><div class="flex h-8 items-center"><h3 class="font-bold">Servers</h3></div><p class="text-sm"> Add different base URLs for your API. You can use <code class="font-code text-c-2">{variables}</code> for dynamic parts. </p></div></div>', 1)),
          (a(!0), v(D, null, I(_.value, (o, y) => (a(), v("div", {
            key: o.uid
          }, [
            c("div", Y, [
              c("div", q, [
                o.description ? (a(), m(t(B), {
                  key: 0,
                  class: "self-center",
                  value: o.description
                }, null, 8, ["value"])) : (a(), v("span", G, "Server " + j(y + 1), 1)),
                n(t(p), {
                  class: "hover:bg-b-3 hover:text-c-1 h-fit p-1.25",
                  variant: "ghost",
                  onClick: (K) => b(o.uid)
                }, {
                  default: f(() => [
                    n(t(V), { class: "size-3.5" })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              t(s) ? (a(), m(R, {
                key: 0,
                collectionId: t(s).uid,
                serverUid: o.uid
              }, null, 8, ["collectionId", "serverUid"])) : $("", !0)
            ])
          ]))), 128)),
          c("div", H, [
            n(t(p), {
              class: "hover:bg-b-2 hover:text-c-1 flex items-center gap-2",
              size: "sm",
              variant: "ghost",
              onClick: S
            }, {
              default: f(() => [
                n(t(E), {
                  class: "inline-flex",
                  icon: "Add",
                  size: "sm",
                  thickness: "1.5"
                }),
                e[1] || (e[1] = c("span", null, "Add Server", -1))
              ]),
              _: 1,
              __: [1]
            })
          ])
        ]),
        n(t(U), {
          size: "xxs",
          state: t(u),
          title: `Delete ${l.value ? (i = t(d)[l.value]) == null ? void 0 : i.url : "Server"}`
        }, {
          default: f(() => [
            n(L, {
              variableName: "Server",
              warningMessage: "Are you sure you want to delete this server? This action cannot be undone.",
              onClose: e[0] || (e[0] = (o) => t(u).hide()),
              onDelete: g
            })
          ]),
          _: 1
        }, 8, ["state", "title"])
      ], 512);
    };
  }
});
export {
  oe as default
};
